import React, { useEffect, useRef, useState } from "react";
import SelectBox from "./SelectBox";
import SelectBoxButton from "./SelectBoxButton";
import { classNames } from "../../../helpers/classNames";
import SelectOptions from "./SelectOptions";
import Image from "../../elements/Image";
import SelectOption from "./SelectOption";
import Search from "../Search";
import NoData from "../../../assets/images/no-results-bg.2d2c6ee3.png";

const Select = ({
  dropdownData = [],
  selectedValue,
  onChange = () => { },
  placeholder = "Select an option",
  isSearch = false,
  xPlacement,
  dropdownClass,
  dropdownButtonClass,
  optionsClass,
  onSearchHandler = () => { },
  onScroll = () => { },
  loading,
  label,
  labelClasses,
  errorType,
  errorText,
  required,
  isDisabled = false,
  checked = true,
  buttonStyle,
  searchValue,
  ...props
}) => {
  const [selected, setSelected] = useState(null);
  const [list, setList] = useState([]);

  useEffect(() => {
    setList(dropdownData);
  }, [JSON.stringify(dropdownData)]);

  useEffect(() => {
    if ((selectedValue || selectedValue !== undefined) && dropdownData && Array.isArray(dropdownData) && dropdownData?.length > 0) {
      setSelected(dropdownData.filter((item) => item?.value === selectedValue || item?._id === selectedValue)?.[0] || null);
    } else {
      setSelected(null);
    }
  }, [JSON.stringify(selectedValue), JSON.stringify(dropdownData)]);

  return (
    <div className="relative w-full">
      {label && (
        <div className={classNames("text-xs font-medium text-text-disabled mb-1  ", labelClasses)}>
          {label}
          {required && (
            <span className="text-[8px] text-red-500 ml-1 absolute top-[-2px]">
              <i className="fa-solid fa-asterisk"></i>
            </span>
          )}
        </div>
      )}
      <SelectBox
        selectedValue={selected}
        onChange={(val) => {
          setSelected(val);
          onChange(val?.value, val);
        }}
        disabled={isDisabled}
        xPlacement={xPlacement}
      >
        {({ open }) => (
          <>
            <SelectBoxButton className="flex items-center w-full cursor-pointer">
              <div className={classNames(`relative w-full h-10 flex items-center gap-2 pr-2 pl-3 rounded-md bg-white border px-3 text-sm text-sidebar !ring-0 !outline-0  transition-all duration-200 ${open ? "border-text-disabled" : "border-text-secondary/50"}`, dropdownButtonClass)}>
                {selected?.image && (
                  <div className="w-7 aspect-1 overflow-hidden rounded-md flex-shrink-0">
                    <Image src={selected?.image} alt={selected?.image} quality={0.2} className={"w-full h-full object-cover object-center"} />
                  </div>
                )}
                {selected?.icon && (
                  <div className="w-5 aspect-1 overflow-hidden rounded-md flex-shrink-0">
                    <div className="w-5 aspect-1 overflow-hidden rounded-md flex-shrink-0">
                      <i className={classNames("fa-fw", selected?.icon)}></i>
                    </div>
                  </div>
                )}
                <div className="whitespace-nowrap flex-grow truncate" style={typeof buttonStyle === "function" ? buttonStyle(selected) : buttonStyle}>
                  {selected?.name || <span className="text-text-disabled">{placeholder}</span>}
                </div>
                <div className="text-[10px] text-slate-400 ml-auto">{loading ? <i className={"fa-duotone fa-spinner-third animate-spin text-sm"} /> : <i className={"fa-light fa-fw fa-chevron-down"}></i>}</div>
              </div>
            </SelectBoxButton>
            <SelectOptions className={classNames("mt-1 w-52 max-h-52 origin-top-right bg-white border-0 divide-y divide-slate-100 rounded-md shadow ring-0 !overflow-hidden", dropdownClass)}>
              {isSearch && (
                <div className="py-2 px-3">
                  <Search
                    placeholder={"Search"}
                    iconClasses={""}
                    search={(e) => {
                      onSearchHandler(e);
                    }}
                    searchValue={searchValue}
                  />
                </div>
              )}
              {Array.isArray(list) && !loading && list?.length > 0 ? (
                <div className="overflow-auto mb-1 w-full p-2 max-h-[324px]" onScroll={onScroll}>
                  {list.map((item, index) => (
                    <SelectOption key={index} value={item} className={"h-9"}>
                      {({ selected }) => (
                        <>
                          <div className={classNames("h-full w-full hover:bg-denim overflow-hidden rounded-md px-3 py-1 flex items-center gap-2 hover:text-white text-sm transition-all duration-200", selected?.value === item?.value ? "bg-denim text-white" : "")}>
                            {checked && <div className="w-6 h-6 flex items-center justify-center">{selected?.value === item?.value && <i className="fa-regular fa-fw fa-check"></i>}</div>}
                            <div className={classNames("truncate   flex items-center gap-2", selected?.value === item?.value ? "font-medium" : " ", item?.class ? item?.class : "")} style={typeof item?.style === "function" ? item?.style(item) : item?.style}>
                              {item?.icon && (
                                <div className="w-5 aspect-1 overflow-hidden rounded-md flex-shrink-0">
                                  <i className={classNames("fa-fw", item?.icon)}></i>
                                </div>
                              )}
                              {item?.image && (
                                <div className="w-7 aspect-1 overflow-hidden rounded-md flex-shrink-0">
                                  <Image src={item.image} alt={item.image} className={"w-full h-full object-cover object-center"} />
                                </div>
                              )}
                              {item?.name}
                            </div>
                          </div>
                        </>
                      )}
                    </SelectOption>
                  ))}
                </div>
              ) : (
                <div className="flex flex-col items-center justify-center w-full py-3 space-y-3">
                  <div className={classNames("relative overflow-hidden w-32 h-32")}>
                    <Image src={NoData} alt="no-data" className="w-full h-full" />
                  </div>
                </div>
              )}
            </SelectOptions>
          </>
        )}
      </SelectBox>
      {errorType && errorType === "error" && (
        <div className="text-xs text-red-600 mt-1">
          <i className="fa-regular fa-fw fa-square-exclamation text-sm mr-1"></i>
          {errorText}
        </div>
      )}
      {errorType && errorType === "warning" && (
        <div className="text-xs text-amber-600 mt-1">
          <i className="fa-regular fa-fw fa-triangle-exclamation text-sm mr-1"></i>
          {errorText}
        </div>
      )}
      {errorType && errorType === "success" && (
        <div className="text-xs text-green-600 mt-1">
          <i className="fa-regular fa-fw fa-circle-check text-sm mr-1"></i>
          {errorText}
        </div>
      )}
      {errorType && errorType === "info" && (
        <div className="text-xs text-sky-600 mt-1">
          <i className="fa-regular fa-fw fa-circle-info text-sm mr-1"></i>
          {errorText}
        </div>
      )}
    </div>
  );
};

export default Select;
